import SermonList from "@jesus-central-church/ui/src/components/sermons/SermonList";
import { fetchChannelRssFeed } from "@jesus-central-church/youtube";
import type { SbSermonList } from "@storyblok/types/287435740670216/storyblok-components";

// eslint-disable-next-line @typescript-eslint/no-unused-vars -- blok required by Storyblok component interface
export async function SermonListComponent({ blok }: { blok: SbSermonList }) {
  const sermons = await fetchChannelRssFeed(
    process.env.NEXT_PUBLIC_YOUTUBE_CHANNEL_ID ?? "",
  );

  if (!sermons) {
    return <div>No sermons found</div>;
  }

  return <SermonList sermons={sermons} />;
}
